"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _publication = require("../common/utils/publication");
var setup = function setup(_ref) {
  var latestAsset = _ref.latestAsset;
  return {
    description: 'Add an AsyncAPI spec that exposes an evented process to consumers and producer application.',
    flows: [{
      label: 'Upload an AsyncAPI',
      callout: 'Support for AsyncAPIs on the Anypoint Platform is limited. [See what is currently supported](https://docs.mulesoft.com/release-notes/platform/event-driven-api).',
      fields: [(0, _publication.apiVersionField)(latestAsset), {
        name: 'mainFile',
        inputType: 'file',
        classifier: 'evented-api',
        extensions: ['.yaml'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }]
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map